import React, { PureComponent } from "react";
import { connect } from "react-redux";
import CurrentResultsCount from "../components/CurrentResultsCount";
import { OFFER_TYPES } from "../constants/offerTypes";

class CurrentResultsCountContainer extends PureComponent {
  render() {
    const { offerType } = this.props;

    const count = this.getOfferDataCount();

    if (count <= 0) {
      return null;
    } else {
      return <CurrentResultsCount count={count} offerType={offerType} />;
    }
  }

  getOfferDataCount() {
    const { offerType, portalData } = this.props;

    if (offerType === OFFER_TYPES.phoneOffer) {
      return portalData.entities.phoneOffers.length;
    } else if (offerType === OFFER_TYPES.proposition) {
      return portalData.entities.propositions.length;
    } else {
      return portalData.entities.simOnlyOffers.length;
    }
  }
}

function mapStateToProps(state) {
  return {
    offerType: state.offerType,
    portalData: state.portalData
  };
}

export default connect(mapStateToProps)(CurrentResultsCountContainer);
